// Webpack and React expect NODE_ENV to always be "development" or "production", so we need another
// env var to track the stage of the frontend app itself so we can support, for example, a "staging"
// environment while still doing a NODE_ENV=production build.
const REACT_ENV = import.meta.env.VITE_REACT_ENV

if(!REACT_ENV) {
  throw new Error("Missing REACT_ENV environment var! Check webpack configs for your stage.")
}

export const
  env = REACT_ENV,
  isDev = REACT_ENV === "development",
  isStaging = REACT_ENV === "staging",
  isProd = REACT_ENV === "production"
